import { Check } from "lucide-react";
import { timeOnly, dateTime } from "../lib/format";

const STEPS = [
  ["requested", "Requested"], ["assigned", "Assigned"], ["accepted", "Accepted"], ["en_route", "En route"],
  ["at_pickup", "At pickup"], ["in_transit", "On board"], ["completed", "Completed"],
];

export function TripProgress({ status }: { status: string }) {
  const idx = STEPS.findIndex(([s]) => s === status);
  if (status === "cancelled") return <p className="rounded-xl bg-amber-50 p-3 text-sm font-semibold text-amber-900" data-testid="trip-progress-cancelled">This booking was cancelled.</p>;
  return (
    <ol className="grid grid-cols-7 gap-1" data-testid="trip-progress">
      {STEPS.map(([s, label], i) => (
        <li key={s} className="flex flex-col items-center gap-1 text-center">
          <span className={`flex h-7 w-7 items-center justify-center rounded-full border-2 text-xs font-bold ${i <= idx ? "border-[#036248] bg-[#036248] text-white" : "border-slate-300 bg-white text-slate-400"}`}>
            {i < idx ? <Check size={14} /> : i + 1}
          </span>
          <span className={`text-[10px] leading-tight sm:text-xs ${i === idx ? "font-bold text-slate-900" : "text-slate-500"}`}>{label}</span>
        </li>
      ))}
    </ol>
  );
}

export function TripTimeline({ timeline }: { timeline: any[] }) {
  return (
    <ul className="space-y-3" data-testid="trip-timeline">
      {[...(timeline || [])].reverse().map((t, i) => (
        <li key={i} className="flex gap-3 text-sm">
          <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-[#036248]" />
          <div>
            <p className="font-medium capitalize text-slate-800">{t.status.replace(/_/g, " ")} <span className="font-normal text-slate-500">· {timeOnly(t.at)}</span></p>
            <p className="text-xs text-slate-500">{t.by_role} · {t.by_name}{t.note ? ` — ${t.note}` : ""}</p>
            <p className="sr-only">{dateTime(t.at)}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
